<section class="bg-light vh-100">
  <router-outlet></router-outlet>
</section>
